import { render, staticRenderFns } from "./channelExpenseStatistics.vue?vue&type=template&id=7236d1b9"
import script from "./channelExpenseStatistics.vue?vue&type=script&lang=js"
export * from "./channelExpenseStatistics.vue?vue&type=script&lang=js"
import style0 from "./channelExpenseStatistics.vue?vue&type=style&index=0&id=7236d1b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports